import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { resetWorkout } from "../../../../../../store/features/workout/workout-slice";
import { useAppDispatch } from "../../../../../../store/config";
import { StyledSelect, StyledSelectOption } from "./style";
import {
  ErrorText,
  StyledModal,
} from "../../../../../../components/common/styles";
import { Flex } from "antd";
import { useTranslation } from "react-i18next";

export const NewWorkoutModal = (props: {
  trainerId: string | undefined;
  modalOpen: boolean;
  setModalOpen: (value: boolean) => void;
  navigateTo: string;
}) => {
  const { trainerId, modalOpen, setModalOpen, navigateTo } = props;
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { t } = useTranslation();

  const [newWorkoutType, setNewWorkoutType] = useState<string | null>(null);
  const [modalError, setModalError] = useState<string | null>(null);

  const handleModalOk = () => {
    if (!newWorkoutType) {
      setModalError(t("Please select a workout type"));
      return;
    }
    setModalOpen(false);
    dispatch(resetWorkout());
    if (trainerId) {
      navigate(navigateTo, {
        state: { type: newWorkoutType },
      });
    }
  };

  return (
    <StyledModal
      title={t("Create Workout")}
      open={modalOpen}
      onOk={handleModalOk}
      onCancel={() => {
        setModalError(null);
        setNewWorkoutType(null);
        setModalOpen(false);
      }}
      centered
      okText={t("Create")}
      cancelText={t("Cancel")}
      width={400}
    >
      <Flex vertical style={{ marginBottom: "40px" }}>
        <p>{t("Select workout type")}</p>
        <StyledSelect
          value={newWorkoutType}
          onChange={(value) => {
            setModalError(null);
            setNewWorkoutType(value as string);
          }}
          options={[
            { label: t("Video (VOD)"), value: "video" },
            { label: t("Exercise List"), value: "exercises" },
          ]}
          optionRender={(item) => (
            <StyledSelectOption>{item.label}</StyledSelectOption>
          )}
          placeholder={t("Select")}
        />
        {modalError && <ErrorText>{modalError}</ErrorText>}
      </Flex>
    </StyledModal>
  );
};
